<template>
  <VDialogV3
    id="person-card"
    position="right"
    width="600px"

    :entity="localPerson"
    :context-menu="PersonsService.contextMenu"
    :submit-method="submit"

    @close="onClose"
  >
    <section class="person-info">
      <header>Основная информация</header>

      <VInput
        ref="person-name"
        v-model="localPerson.name"
        label="ФИО"
        layout="vertical"
        required
      />

      <VInput
        ref="person-email"
        v-model="localPerson.email"
        label="Email"
        layout="vertical"
        type="email"
        required
      />

      <VSelect
        ref="person-timezone"
        v-model="localPerson.timeZone"
        placeholder="Введите название города"
        label="Часовой пояс"
        layout="vertical"
        option-label="stringRepresentation"
        :options="timeZoneOptions"
        required
      />

      <VTextarea
        ref="person-comment"
        v-model="localPerson.comment"
        label="Комментарий"
        layout="vertical"
      />
    </section>

    <section>
      <VSelect
        v-if="isSWPartner"
        v-model="localPerson.swPortalEmployee"
        placeholder="Введите ФИО сотрудника"
        label="Сотрудник в ИС Сибирского здоровья"
        layout="vertical"
        :search-function="SWPortalTaskService.searchEmployees"
      />
    </section>

    <hr>

    <ContactsSection
      ref="contactsSection"
      :person="localPerson"
      @contact:updated="isChanged = true"
    />
  </VDialogV3>
</template>

<script lang="ts">

import Person               from "@/domains/Persons/Person";
import PersonsService       from "@/domains/Persons/PersonsService";
import TimeZonesService     from "@/domains/TimeZones/TimeZonesService";
import SWPortalTasksService from '@/domains/SWPortalTask/SWPortalTasksService';
import TimeZone             from "@/domains/TimeZones/TimeZone";

import ContactsSection      from "@/domains/Contacts/components/ContactsSection/ContactsSection.vue";

export default defineComponent({
  name: "PersonCard",

  components: {
    ContactsSection,
  },

  props: {
    /** ID контактного лица — карточка сама загрузит объект */
    id: {
      type: Number,
      default: null,
    },

    /** Партнёр нового контактного лица — нужен только при создании */
    partnerId: {
      type: Number,
      default: null,
    },
  },

  setup() {
    return {
      PersonsService,
      SWPortalTaskService: SWPortalTasksService,
    };
  },

  data() {
    return {
      localPerson: null as Person | null,

      timeZoneOptions: [] as TimeZone[],

      /** Контакты удалялись — при закрытии хост должен обновиться */
      isChanged: false,
    }
  },

  computed: {
    isSWPartner() {
      return this.$core.currentUser.isPrivileged
        && this.$core.currentUser.isAdmin
        && this.$core.currentUser?.canEditPaymentExternalId;
    },
  },

  async created() {
    await this.init();
  },

  methods: {
    /**
     * Лицо присваивается последним: пока localPerson пустой, VDialogV3
     * показывает лоадер, поэтому часовые пояса успевают подтянуться.
     */
    async init(): Promise<void> {
      const timeZonesPromise = TimeZonesService.getList();
      let person: Person | null;

      if (this.$core.utils.isNullOrUndefined(this.id) === false) {
        person = await PersonsService.get(this.id);
      }
      else {
        person = Person.fromPartner(this.partnerId);
      }

      this.timeZoneOptions = await timeZonesPromise;
      this.localPerson     = person;
    },

    /**
     * Сохранение через submitMethod: валидацию, блокировку кнопки и resolve()
     * делает VDialogV3. Контакты нового лица сохраняются сразу после его создания.
     */
    async submit(): Promise<boolean> {
      let isSubmitted = false;

      if (this.localPerson.isExisting === true) {
        /** ждем обновления или создания контактов в ContactsSection */

        await (this.$refs.contactsSection as any).updateContacts(this.localPerson.id);

        /** затем делаем обновление контактного лица */

        isSubmitted = await PersonsService.update(this.localPerson) !== null;
      }
      else {
        const createdPerson = await PersonsService.add(this.localPerson, this.localPerson.partnerId);

        if (createdPerson !== null) {
          await (this.$refs.contactsSection as any).updateContacts(createdPerson.id);

          isSubmitted = true;
        }
        else {
          // ошибку показал сервис
        }
      }

      return isSubmitted;
    },

    onClose(): void {
      if (this.isChanged === true) {
        this.$core.dialogs.PersonCard.resolve();
      }
      else {
        // ничего не сохраняли — диалог закроет сам VDialogV3
      }
    },
  },
})
</script>